import React, { Suspense, useEffect, useState } from "react";
import { Canvas } from "@react-three/fiber";
import CameraControls from "../objects/CameraControls";
import Ground from "../objects/Ground";
import VideoWall from "../objects/VideoWall";
import CameraLight from "../objects/CameraLight";
import useStore from "../modules/useStore";
import { useSprings } from "react-spring";


export default function World() {
  const { projects, currentProject } = useStore(({ projects, currentProject }) => ({ projects, currentProject }));
  const [clicked, setClicked] = useState(false);
  const [ready, setReady] = useState(false);
  const [springs, api] = useSprings(projects.length, (index) => ({
    from: { pos: [index * 8, 1.35, -7] },
    pos: [index * 8, 1.35, currentProject === index ? -2 : -7]
  }));
  
  useEffect(() => {
    if (ready && !clicked) setClicked(true);
  }, [ready, clicked]);

  useEffect(() => {
    api.start(index => ({
      pos: [index * 8, 1.35, currentProject === index ? -2 : -7],
      // delay: currentProject === index ? 500 : 0,
      config: {
        mass: 4,
        damping: 0.9,
        tension: 120,
        friction: 60,
      },
    }))
    return () => api.stop()
  }, [currentProject, api])

  const store = { clicked, setClicked, ready, setReady };

  console.log(springs);
  return (
    <>
      <Canvas
        className="fixed w-screen h-full h-screen z-0"
        concurrent
        gl={{ alpha: false }}
        pixelRatio={[1, 1.5]}
        camera={{ position: [0, 3, 100], fov: 15 }}
      >
        <color attach="background" args={["black"]} />
        <fog attach="fog" args={["black", 17, 27]} />
        <Suspense fallback={null}>
          <group position={[0, -1, 0]}>
            {/* <Carla
              rotation={[0, Math.PI - 0.4, 0]}
              position={[-1.2, 0, 0.6]}
              scale={[0.26, 0.26, 0.26]}
            /> */}
            {projects.map((p, index) => (
              <>
                <VideoWall
                  {...store}
                  position={springs[index].pos}
                  key={p.title}
                  video={p.video}
                  link={p.link}
                  index={index}
                />
              </>
            ))}
            <Ground />
          </group>
          <ambientLight intensity={0.1} />
          <CameraLight />
          <CameraControls start={ready && clicked} set={setReady} />
        </Suspense>
      </Canvas>
    </>
  );
}
